var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:_vm.placeHolderCircleClasses},_vm._l((3),function(n){return _c('span',{key:n,staticClass:"placeholder-circle"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }